import { ENDPOINT, HTTP } from "../config"
import { fetchFromLawfeed } from "../fetchFromLawfeed"

export const createCase = async (caseData) => {
    const response = await fetchFromLawfeed({
        method: HTTP.POST,
        endpoint: ENDPOINT.createCase,
        body: caseData
    })
    console.log(response)   
    return response
    
}